import { parseNameStatusLines, parseNumstat } from '../parse/index.js';

/** Count distinct paths with working-tree changes vs `HEAD`, including untracked (matches changes tab). */
export function workingTreeChangedPathCount(
  nameStatusLines: string[],
  numstatLines: string[],
  untrackedLines: string[],
): number {
  const kindByPath = parseNameStatusLines(nameStatusLines);
  const numByPath = parseNumstat(numstatLines);
  const paths = new Set<string>([...kindByPath.keys(), ...numByPath.keys()]);
  for (const p of untrackedLines.map((s) => s.trim()).filter(Boolean)) {
    paths.add(p);
  }
  return paths.size;
}
